import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { apiErr } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import Header from "../components/Header";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "", student_class: "X" });
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup(form);
      toast.success("Welcome! Your 20-day free trial has started.");
      nav("/dashboard");
    } catch (e) {
      toast.error(apiErr(e, "Signup failed"));
    } finally { setBusy(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen">
      <Header />
      <div className="max-w-md mx-auto px-4 py-12">
        <div className="brut-card p-8 bg-white">
          <h1 className="text-3xl font-black mb-1">Create account</h1>
          <p className="text-neutral-600 mb-6">Start your 20-day free trial. No card needed.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Name</Label>
              <Input data-testid="signup-name" required value={form.name} onChange={upd("name")}
                className="brut-input rounded-none mt-1" />
            </div>
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Email</Label>
              <Input data-testid="signup-email" type="email" required value={form.email} onChange={upd("email")}
                className="brut-input rounded-none mt-1" />
            </div>
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Password</Label>
              <Input data-testid="signup-password" type="password" required minLength={4} value={form.password}
                onChange={upd("password")} className="brut-input rounded-none mt-1" />
            </div>
            <div>
              <Label className="text-xs tracking-[0.2em] uppercase font-bold">Class</Label>
              <div className="mt-1 grid grid-cols-2 gap-2">
                {["IX", "X"].map((c) => (
                  <button
                    key={c}
                    type="button"
                    data-testid={`signup-class-${c}`}
                    onClick={() => setForm({ ...form, student_class: c })}
                    className={`brut-border brut-shadow-sm py-3 font-bold transition-transform ${
                      form.student_class === c ? "bg-[#FFB3BA]" : "bg-white hover:-translate-y-0.5"
                    }`}
                  >
                    Class {c}
                  </button>
                ))}
              </div>
            </div>
            <Button data-testid="signup-submit" type="submit" disabled={busy}
              className="brut-btn rounded-none w-full bg-[#1A1A1A] text-white hover:bg-[#1A1A1A]">
              {busy ? "Creating…" : "Create Account & Start Trial"}
            </Button>
          </form>
          <p className="mt-6 text-sm">
            Already have an account? <Link to="/login" className="font-bold underline">Log in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
